import React from 'react';
import { useNavigate } from 'react-router-dom';

import { List, Typography } from 'antd';
import styled from 'styled-components';

import SettingsIcon from './SettingsIcon';
import { SettingsListItem as SettingsListItemType } from './types';

const StyledListItem = styled(List.Item)`
  background-color: white;
  cursor: pointer;
`;

const BetaBadge = styled.span`
  margin-right: 12px;
  padding: 2px 5px;
  border-radius: 2px;
  background-image: linear-gradient(119deg, #88f, #55f 100%);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: normal;
  color: white;
`;

type Props = {
  item: SettingsListItemType;
  isBeta?: boolean;
};

const SettingsListItem = ({ item, isBeta }: Props) => {
  const navigate = useNavigate();
  const handleItemClick = () => {
    navigate(item.url);
  };

  return (
    <StyledListItem key={item.title} style={{ padding: '12px 10px' }} tabIndex={0} onClick={handleItemClick}>
      <List.Item.Meta
        className="custom-list-item-meta"
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
        avatar={
          <SettingsIcon
            style={{
              backgroundColor: item.icon.backgroundColor,
              backgroundImage: item.icon.backgroundImage,
              borderRadius: '4px',
            }}
            size={30}
            src={<img src={item.icon.url} style={{ width: '20px', height: '20px', borderRadius: '4px' }} />}
          />
        }
        title={
          <Typography.Text strong style={{ marginBottom: 0 }}>
            {item.title}
          </Typography.Text>
        }
        description={
          <Typography.Text style={{ color: '#6d6d6d', fontSize: '12px' }}>{item.description}</Typography.Text>
        }
      />
      {isBeta && <BetaBadge>BETA</BetaBadge>}
      <img src="/icons/chevron-right.svg" style={{ width: '24px', height: '24px' }} />
    </StyledListItem>
  );
};

export default SettingsListItem;
